export function UnauthorizedIcon() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4797 14.9957C18.2459 14.9152 19.8513 14.9626 20.663 14.9676L25.7223 14.975L41.7964 14.9982L56.243 14.9727C58.1071 14.9746 59.9722 14.9399 61.8354 14.9665C63.2483 14.9867 64.5255 15.2009 65.6557 16.0474C67.81 17.6606 67.5794 19.7327 67.5731 22.0255L67.5718 26.5497L67.5524 40.5059L67.5698 54.462L67.571 58.7194C67.5716 59.3657 67.6374 60.2661 67.5535 60.8968C67.2345 63.2941 65.4911 64.7525 62.9855 64.9859C59.2808 65.0765 55.2247 64.9994 51.4996 64.9941L32.9307 64.9869L22.8204 64.9936C18.8169 65.0036 12.7142 65.9027 12.4536 60.2595C12.3571 58.1683 12.4257 55.9262 12.4297 53.8249L12.4435 40.4052L12.4388 25.7959L12.4415 21.505C12.4395 19.6956 12.2825 18.1639 13.5967 16.6572C14.6227 15.4807 15.9571 15.1429 17.4797 14.9957Z"
        fill="#171717"
      />
      <path
        d="M14.1775 26.4131L65.9353 26.4212L65.9401 47.6638C65.9367 51.7004 65.9404 55.7396 65.9459 59.7762C65.9475 60.9223 65.6884 61.8468 64.7841 62.6742C63.2797 63.7518 61.1403 63.4273 59.3273 63.4113L53.8863 63.3926C48.0611 63.4219 42.2357 63.4221 36.4105 63.3931L23.4443 63.4073C21.3609 63.4109 19.0432 63.4831 16.9776 63.3389C16.2291 63.3226 14.9419 62.5353 14.6019 61.8856C13.9541 60.6479 14.1791 57.855 14.1757 56.5485L14.1766 48.6496L14.1775 26.4131Z"
        fill="white"
      />
      <path
        d="M39.1985 31.0803C47.3307 30.6766 54.2748 36.5118 54.7128 44.1172C55.1507 51.7226 48.9169 58.2215 40.7854 58.637C32.6448 59.053 25.6867 53.215 25.2483 45.6013C24.8098 37.9875 31.0574 31.4845 39.1985 31.0803Z"
        fill="#FECD3B"
      />
      <path
        d="M39.0807 36.7713C41.993 36.3174 44.5429 37.7518 46.5825 39.5093C46.5531 38.753 46.3346 37.7295 47.2245 37.4109C47.6937 37.1741 48.1789 37.9016 48.1861 38.2754C48.2018 39.0823 48.6353 42.3374 47.4728 42.4971C47.0427 42.5562 43.5896 42.5477 43.3675 42.254C42.095 40.5722 44.4849 40.8115 45.4428 40.861C43.9478 39.3854 42.883 38.6475 40.6377 38.442C34.1317 37.8465 30.3358 44.9079 34.5115 49.5357C35.81 50.9748 37.6705 51.7199 39.689 51.8546C40.3187 51.948 41.4587 51.7264 42.0702 51.5455C43.8939 51.006 45.3913 49.827 46.3187 48.2677C46.5607 47.8608 46.6485 47.2755 46.8814 46.8516C47.1079 46.3828 47.7615 46.2258 48.2009 46.5212C48.7846 46.9269 48.4566 47.5581 48.2648 48.064C46.2593 53.3519 39.2118 55.1966 34.493 51.827C32.6123 50.488 31.3916 48.4938 31.1094 46.299C30.4301 41.3626 33.839 37.4019 39.0807 36.7713Z"
        fill="#171717"
      />
      <path
        d="M17.2273 16.6786C22.6719 16.5511 28.623 16.6546 34.1079 16.6594L61.4749 16.6535C67.0388 16.6611 65.9544 21.0645 65.9285 24.888C64.8017 24.8997 63.6206 24.8609 62.4891 24.8379L31.2338 24.8465C25.7442 24.8326 19.6339 24.7247 14.1775 24.862C14.2228 21.8613 13.0978 17.2768 17.2273 16.6786Z"
        fill="white"
      />
      <path
        d="M19.4958 19.9453C19.9352 19.8182 20.4138 19.9247 20.745 20.2231C21.0763 20.5215 21.2079 20.9647 21.0886 21.3801C20.9694 21.7956 20.6182 22.1176 20.1717 22.2207C19.5082 22.374 18.8347 22.0059 18.6518 21.39C18.4689 20.7742 18.8429 20.134 19.4958 19.9453Z"
        fill="#171717"
      />
      <path
        d="M25.489 19.8096C27.255 20.0878 27.262 21.6543 25.6913 22.3151C24.8 22.301 24.5341 21.693 24.2852 21.0208C24.6079 20.256 24.6889 20.1423 25.489 19.8096Z"
        fill="#171717"
      />
      <path
        d="M31.093 19.8766C32.7951 19.7722 33.1591 21.4867 31.6792 22.2635C30.2645 22.5003 29.508 20.6873 31.093 19.8766Z"
        fill="#171717"
      />
    </svg>
  );
}
